import { AppData } from "./models";
import { base64, json, logger, queryString } from ".";
function getAsync() {
    const promise = new Promise((resolve, reject) => {
        try {
            const parsedQueryString = queryString.parse();
            const searchKey = "AppData";
            logger.info("Parsing App Data");
            const appDataKey = Object.keys(parsedQueryString).find((key) => key.toLowerCase() === searchKey.toLowerCase());
            const appDataProperty = appDataKey;
            const value = parsedQueryString[appDataProperty];
            logger.debug(`App Data as Base64: ${value}`);
            const parsedValue = base64.decode(value);
            logger.debug(`App Data as Text: ${parsedValue}`);
            const parsedJson = JSON.parse(parsedValue);
            const result = new AppData(parsedJson.accountToken, parsedJson.profile.name, parsedJson.profile.website, parsedJson.profile.email, parsedJson.profile.phone_number);
            logger.debug(`App Data casted as object: ${json.format(result)}`);
            logger.info("App data retrived with success!");
            resolve(result);
        }
        catch (err) {
            logger.error(`The informed value in AppData is not a valid Base64. ${err}`);
            reject(new Error(`The informed value in AppData is not a valid Base64.`));
        }
    });
    return promise;
}
export const appData = {
    getAsync,
};
